import { Button, Col, Container, Quote, Row } from 'darrius';

import { GrYoutube } from 'react-icons/gr';

import styles from './Testimonial.module.scss';

export const Testimonial = () => {
  return (
    <Container>
      <Row className="center-sm space-bottom">
        <Col className="col-md-6 col-sm-11 space-bottom">
          <img
            className={styles['signup-mgm__depoiment__image']}
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/imagePro/aline-super-pro.png`}
            alt="Foto da Aline, profissional cadastrada no GetNinjas. Ela é branca, dos cabelos pretos, com uma camisa preta escrito GetNinjas. Está em um fundo branco com amarelo, simbolizando as cores do GetNinjas."
          />
        </Col>
        <Col className="col-md-4 center col-sm-11 space-bottom">
          <div className={styles['signup-mgm__depoiment__quote']}>
            <Quote
              title="Aline, "
              subTitle="profissional cadastrada no GetNinjas"
              text="Trabalhar no GetNinjas foi uma mudança radical. Hoje é a minha principal fonte de renda, eu trabalho apenas com o GetNinjas"
            />

            <Button.Link
              className="space-top depoiment__quote__button"
              variation="secondary"
              size="small"
              target="_blank"
              href="https://www.youtube.com/watch?v=KaNfuPFiFnw&ab_channel=GetNinjas"
            >
              <GrYoutube size={32} color="red" />
              Clique aqui para assistir o vídeo com o depoimento da Aline
            </Button.Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
